import { render, staticRenderFns } from "./absent_canada_calculator.vue?vue&type=template&id=41e3ab70&"
import script from "./absent_canada_calculator.vue?vue&type=script&lang=js&"
export * from "./absent_canada_calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports